enum RootActionTypes {
  RESET = 'ROOT/RESET_APP',
}

export default RootActionTypes;
